import {useMemo} from 'react';
import {useProfile} from '../../Providers/ProfileProvider';

export const useNewDesignsEnabled = () => {
  const {profile} = useProfile();
  const {universalHelpUseNewDesign, enableUniversalHelp} = profile.featureFlags;

  return useMemo(
    () => enableUniversalHelp && universalHelpUseNewDesign,
    [enableUniversalHelp, universalHelpUseNewDesign],
  );
};
